import React from 'react';
// routing
import {Redirect} from 'react-router-dom';
import { SecureRoute } from '@okta/okta-react';



// user state
import {useSelector} from 'react-redux';
import {selectUsers} from '../state/reducers/userSlice';

const PrivateRoute = ({component: Component, ...rest}) => {
  const {user, isAuthenticated} = useSelector(selectUsers);

  const userAuthentication = () => {
    const token = user ? user?.token : false;
    try {

      if (
        isAuthenticated && token
      ) {
        return true;
      } else {
        return false;
      }
    } catch (err) {
      return false;
    }
  };
  return (
    <SecureRoute
      {...rest}
      render={(props) =>
        userAuthentication() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: '/',
            }}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
